(function () {
  "use strict";

  if (window.MarineMaxHeadlessRecommendationsRuntime) return;

  const COMMERCE_ESM =
    "https://static.cloud.coveo.com/shopify/v1/headless/commerce.esm.js";
  const PRODUCT_CARD_SECTION_ID = "product-card-search";
  const LIQUID_PRODUCT_SECTION_FETCH_CONCURRENCY = 4;
  const RECOMMENDATION_CONFIG_SELECTOR =
    "[data-coveo-headless-recommendations-config]";
  const RECOMMENDATION_PRODUCT_SELECTOR =
    "[data-coveo-recommendation-product]";
  const RECOMMENDATION_PRODUCT_LINK_SELECTOR =
    "a.coveo-search-card__link";
  const RECOMMENDATION_PRODUCT_SELECTION_EVENTS = [
    "click",
    "auxclick",
    "contextmenu",
  ];
  const SELECTED_PRODUCT_CONTEXT_STORAGE_KEY =
    "marinemax:coveo-selected-product-context";
  const SELECTED_PRODUCT_CONTEXT_MAX_AGE_MS = 60 * 60 * 1000;
  const recommendationInstances = new Map();
  const recommendationBootstraps = new Map();

  function getRecommendationConfigKey(options) {
    const config = options || {};
    return JSON.stringify([
      config.slotId || "",
      config.productId || "",
      config.limit || "",
      !!config.enableSlider,
      config.sectionId || "",
      config.configUrl || "",
      config.marketId || "",
      !!config.hideWhenEmpty,
      !!config.hideUntilLoaded,
      config.columnsMobile || "",
      config.columnsTablet || "",
      config.columnsDesktop || "",
      config.syncLocationContext === true,
      config.useStoredLocationWithoutRadius !== false,
    ]);
  }

  function isRecommendationInstanceActive(containerId, instance) {
    return (
      !!instance &&
      instance.active &&
      recommendationInstances.get(containerId) === instance
    );
  }

  function disposeRecommendationInstance(containerId, instance) {
    const current = instance || recommendationInstances.get(containerId);
    if (!current) return false;

    current.active = false;
    current.renderVersion += 1;
    if (typeof current.unsubscribe === "function") {
      try {
        current.unsubscribe();
      } catch (_) {}
      current.unsubscribe = null;
    }
    if (
      current.onProductClick &&
      typeof current.container?.removeEventListener === "function"
    ) {
      RECOMMENDATION_PRODUCT_SELECTION_EVENTS.forEach((eventName) => {
        current.container.removeEventListener(
          eventName,
          current.onProductClick,
          true,
        );
      });
      current.onProductClick = null;
    }
    current.renderedProducts.clear();

    if (
      window.__coveoRecommendationsControllers?.[containerId] ===
      current.controller
    ) {
      delete window.__coveoRecommendationsControllers[containerId];
    }
    if (
      window.__coveoRecommendationsEngines?.[containerId] === current.engine
    ) {
      delete window.__coveoRecommendationsEngines[containerId];
    }
    if (recommendationInstances.get(containerId) === current) {
      recommendationInstances.delete(containerId);
    }
    return true;
  }

  function getSelectedRecommendationProductId() {
    try {
      const raw = window.sessionStorage.getItem(
        SELECTED_PRODUCT_CONTEXT_STORAGE_KEY,
      );
      if (!raw) return "";
      const saved = JSON.parse(raw);
      const currentPath = window.location.pathname.replace(/\/+$/, "") || "/";
      const savedPath =
        String((saved && saved.productPath) || "").replace(/\/+$/, "") || "/";
      const savedAt = Number(saved && saved.savedAt);
      const isFresh =
        Number.isFinite(savedAt) &&
        Date.now() - savedAt < SELECTED_PRODUCT_CONTEXT_MAX_AGE_MS;
      if (!isFresh || savedPath !== currentPath) return "";
      const permanentId = String((saved && saved.permanentId) || "").trim();
      return permanentId.startsWith("gid://shopify/ProductVariant/")
        ? permanentId
        : "";
    } catch (_) {
      return "";
    }
  }

  function createRecommendationOptions(config, container) {
    let productId = config.productId || null;
    if (config.mode === "product") {
      const selectedProductId = getSelectedRecommendationProductId();
      productId = selectedProductId || config.fallbackProductId || "";
      if (!productId) return null;

      container.dataset.coveoRecommendationProductId = productId;
      container.dataset.coveoRecommendationProductIdSource = selectedProductId
        ? "PLP permanentid"
        : "Shopify variant GID fallback";
      console.log(
        `[Coveo Recs] PDP source=${container.dataset.coveoRecommendationProductIdSource} productId=${productId} productPath=${window.location.pathname}`,
      );
    }

    return {
      columnsDesktop: config.columnsDesktop,
      columnsMobile: config.columnsMobile,
      columnsTablet: config.columnsTablet,
      configUrl: config.configUrl,
      containerId: config.containerId,
      enableSlider: config.enableSlider,
      hideUntilLoaded: config.hideUntilLoaded,
      hideWhenEmpty: config.hideWhenEmpty,
      limit: config.limit,
      marketId: config.marketId,
      productId,
      sectionId: config.sectionId,
      slotId: config.slotId,
    };
  }

  function disposeRecommendationBootstrap(containerId, bootstrap) {
    const current = bootstrap || recommendationBootstraps.get(containerId);
    if (!current) return false;
    if (current.observer) {
      current.observer.disconnect();
      current.observer = null;
    }
    if (recommendationBootstraps.get(containerId) === current) {
      recommendationBootstraps.delete(containerId);
    }
    return true;
  }

  function registerRecommendationConfig(configElement) {
    let config;
    try {
      config = JSON.parse(configElement.textContent || "{}");
    } catch (error) {
      console.error("[Coveo Recs] Invalid recommendation config:", error);
      return;
    }

    const containerId = String(config.containerId || "").trim();
    if (!containerId || !config.slotId) return;
    const container = document.getElementById(containerId);
    if (!container) return;
    const options = createRecommendationOptions(config, container);
    if (!options) return;

    const existingBootstrap = recommendationBootstraps.get(containerId);
    if (
      existingBootstrap &&
      existingBootstrap.configElement === configElement &&
      existingBootstrap.container === container
    ) {
      return;
    }
    if (existingBootstrap) {
      disposeRecommendationBootstrap(containerId, existingBootstrap);
      disposeRecommendationInstance(containerId);
    }

    const bootstrap = {
      config,
      configElement,
      container,
      observer: null,
      options,
      promise: null,
      started: false,
    };
    recommendationBootstraps.set(containerId, bootstrap);

    const start = function () {
      if (bootstrap.started) return bootstrap.promise;
      bootstrap.started = true;
      bootstrap.promise = window.initCoveoHeadlessRecommendations(options);
      return bootstrap.promise;
    };

    if (typeof window.IntersectionObserver !== "function") {
      start();
      return;
    }
    bootstrap.observer = new window.IntersectionObserver(
      function (entries) {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        bootstrap.observer.disconnect();
        bootstrap.observer = null;
        start();
      },
      { rootMargin: "200px 0px" },
    );
    bootstrap.observer.observe(
      container.closest(".shopify-section") || container,
    );
  }

  function initializeRecommendationConfigs(scope) {
    const searchRoot =
      scope && typeof scope.querySelectorAll === "function" ? scope : document;
    if (typeof searchRoot.querySelectorAll !== "function") return;
    if (
      typeof searchRoot.matches === "function" &&
      searchRoot.matches(RECOMMENDATION_CONFIG_SELECTOR)
    ) {
      registerRecommendationConfig(searchRoot);
    }
    searchRoot
      .querySelectorAll(RECOMMENDATION_CONFIG_SELECTOR)
      .forEach(registerRecommendationConfig);
  }

  function buildCoveoAppProxyUrl(marketId) {
    let url =
      "/apps/coveo?marketId=" +
      encodeURIComponent(marketId != null ? String(marketId) : "");
    try {
      const ci =
        typeof window !== "undefined" ? window.__coveoCustomerIdentity : null;
      if (ci && ci.id != null) {
        url += "&customer_id=" + encodeURIComponent(String(ci.id));
      }
      if (ci && ci.email) {
        url += "&customer_email=" + encodeURIComponent(String(ci.email));
      }
    } catch (_) {}
    return url;
  }

  function parsePriceUsd(val) {
    if (val == null) return null;
    const num =
      typeof val === "number"
        ? val
        : parseFloat(String(val).replace(/[^0-9.-]/g, ""));
    if (!Number.isFinite(num)) return null;
    if (num >= 1e10 && Number.isInteger(num)) return num / 100;
    return num;
  }

  const COVEO_PLACEHOLDER_SOLD_GHOST_PRICE_USD = 19.99;

  function isCoveoPlaceholderSoldGhostProduct(p) {
    if (!p || typeof p !== "object") return false;
    const raw =
      p.ec_promo_price ??
      p.ec_price ??
      getProductField(p, ["ec_promo_price", "ec_price", "price"]);
    const n = parsePriceUsd(raw);
    if (n == null) return false;
    return Math.abs(n - COVEO_PLACEHOLDER_SOLD_GHOST_PRICE_USD) < 0.01;
  }

  function getProductPathFromClickUri(clickUri) {
    if (!clickUri || typeof clickUri !== "string") return null;
    const s = String(clickUri).trim();
    if (s.startsWith("/")) return s.split("?")[0];
    try {
      const url = new URL(s, window.location.origin);
      return url.pathname.split("?")[0];
    } catch (_) {
      return null;
    }
  }

  async function fetchLiquidProductCard(clickUri, fallbackCardFn) {
    const path = getProductPathFromClickUri(clickUri);
    if (!path || !path.startsWith("/products/")) {
      return fallbackCardFn ? fallbackCardFn() : "";
    }
    const url = path + "?section_id=" + PRODUCT_CARD_SECTION_ID;
    const fb = () => (fallbackCardFn ? fallbackCardFn() : "");
    const maxAttempts = 4;
    for (let attempt = 0; attempt < maxAttempts; attempt++) {
      try {
        const res = await fetch(url);
        if (res.status === 429 && attempt < maxAttempts - 1) {
          await new Promise((r) =>
            setTimeout(r, 400 * (attempt + 1) + Math.floor(Math.random() * 150)),
          );
          continue;
        }
        if (!res.ok) throw new Error("Fetch failed");
        const html = (await res.text()).trim();
        if (!html || /Liquid error/i.test(html)) return fb();
        return unwrapProductCardSection(html);
      } catch (_) {
        if (attempt >= maxAttempts - 1) return fb();
        await new Promise((r) => setTimeout(r, 220 * (attempt + 1)));
      }
    }
    return fb();
  }

  function unwrapProductCardSection(html) {
    const source = String(html || "").trim();
    if (!source) return source;

    const probe = document.createElement("div");
    probe.innerHTML = source;
    const sectionWrapper =
      probe.querySelector("#shopify-section-product-card-search") ||
      probe.querySelector(".product-card-search-section");
    if (!sectionWrapper?.classList.contains("shopify-section")) return source;

    const card = sectionWrapper.firstElementChild;
    return card ? card.outerHTML : "";
  }

  function escapeAttr(str) {
    if (!str) return "";
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function escapeHtml(str) {
    if (!str) return "";
    const div = document.createElement("div");
    div.textContent = str;
    return div.innerHTML;
  }

  function getProductField(p, keys) {
    const af = p.additionalFields || {};
    for (const k of keys) {
      let v = p[k];
      if (v == null || v === "") v = af[k];
      if (v == null || v === "") v = af[k.replace(".", "_")];
      if (v != null && v !== "") {
        return typeof v === "object" && v.value != null ? v.value : v;
      }
    }
    return null;
  }

  function renderFallbackCard(p) {
    const url = p.clickUri || "#";
    const name =
      getProductField(p, ["ec_name", "ec_product_name", "name", "title"]) ||
      "Product";
    const img =
      (p.ec_thumbnails && p.ec_thumbnails[0]) ||
      (p.ec_images && p.ec_images[0]) ||
      "";
    const rawPrice =
      p.ec_promo_price ??
      p.ec_price ??
      getProductField(p, ["ec_promo_price", "ec_price", "price"]);
    let priceStr = "";
    if (rawPrice != null) {
      const num =
        typeof rawPrice === "number"
          ? rawPrice
          : parseFloat(String(rawPrice).replace(/[^0-9.-]/g, ""));
      if (!isNaN(num)) {
        priceStr = new Intl.NumberFormat(undefined, {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(num);
      }
    }
    const priceInner = priceStr
      ? `<span>${escapeHtml(priceStr)}</span>`
      : `<span class="coveo-search-card__request-link">Request pricing</span>`;
    return `<div class="f-column card coveo-search-card-wrapper" role="listitem">
      <div class="coveo-search-card coveo-search-card--fallback">
        <a href="${escapeAttr(url)}" class="coveo-search-card__link">
          <div class="coveo-search-card__image-wrap">
            ${img ? `<img src="${escapeAttr(img)}" alt="${escapeAttr(name)}" loading="lazy" class="coveo-search-card__image" />` : '<div class="coveo-search-card__placeholder"></div>'}
          </div>
          <div class="coveo-search-card__info">
            <div class="coveo-search-card__top-row">
              <div class="coveo-search-card__meta">
                <span class="coveo-search-card__length coveo-search-card__meta-placeholder">&nbsp;</span>
              </div>
              <div class="coveo-search-card__tag-badges"></div>
            </div>
            <div class="coveo-search-card__heading-block">
              <h3 class="coveo-search-card__title">${escapeHtml(name)}</h3>
            </div>
            <hr class="coveo-search-card__divider" />
            <div class="coveo-search-card__footer">
              <div class="coveo-search-card__compare-presentation coveo-search-card__compare-presentation--layout-only" aria-hidden="true">
                <span class="coveo-search-card__compare-box"></span>
                <span class="coveo-search-card__compare-label">Compare</span>
              </div>
              <div class="coveo-search-card__footer-main">
                <div class="coveo-search-card__price-wrap">${priceInner}</div>
                <span class="coveo-search-card__stock-id coveo-search-card__stock-id--placeholder" aria-hidden="true">&nbsp;</span>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>`;
  }

  function getRecommendationsSection(sectionId, container) {
    if (container) {
      const closestSection = container.closest(".section");
      if (closestSection) return closestSection;
    }
    if (sectionId) {
      return document.querySelector(".section-" + sectionId);
    }
    return null;
  }

  function setRecommendationsSectionVisible(sectionId, container, visible) {
    const section = getRecommendationsSection(sectionId, container);
    if (!section) return;
    section.classList.toggle("hidden", !visible);
    section.hidden = !visible;
    section.style.display = visible ? "" : "none";
    section.setAttribute("aria-hidden", visible ? "false" : "true");
  }

  function syncRecommendationsControls(sectionId, container, itemCount) {
    const section = getRecommendationsSection(sectionId, container);
    if (!section) return;
    const controls = section.querySelector(".swiper-controls");
    if (!controls) return;
    const scrollContainer =
      section.querySelector("#coveo-recommendations-grid-" + sectionId) ||
      container?.parentElement ||
      null;
    const hasOverflow =
      !!scrollContainer &&
      scrollContainer.scrollWidth - scrollContainer.clientWidth > 8;
    const columnsDesktop = Number(section.dataset.coveoColumnsDesktop || 4) || 4;
    const columnsTablet = Number(section.dataset.coveoColumnsTablet || 3) || 3;
    const columnsMobile = Number(section.dataset.coveoColumnsMobile || 1) || 1;
    let minItemsForControls = columnsDesktop;
    if (window.innerWidth < 768) {
      minItemsForControls = columnsMobile;
    } else if (window.innerWidth < 1024) {
      minItemsForControls = columnsTablet;
    }
    const shouldShowControls =
      itemCount > minItemsForControls && hasOverflow;

    controls.classList.toggle("hidden", !shouldShowControls);
    controls.hidden = !shouldShowControls;
    controls.style.display = shouldShowControls ? "flex" : "none";
    controls.setAttribute("aria-hidden", shouldShowControls ? "false" : "true");
  }

  function selectRecommendationProduct(recommendations, renderedProduct) {
    const product = renderedProduct && renderedProduct.product;
    if (!recommendations || !product) return false;
    try {
      let interactiveProduct = renderedProduct.interactiveProduct;
      if (!interactiveProduct) {
        const buildInteractiveProduct =
          typeof recommendations.interactiveProduct === "function"
            ? recommendations.interactiveProduct.bind(recommendations)
            : typeof recommendations.InteractiveProduct === "function"
              ? recommendations.InteractiveProduct.bind(recommendations)
              : null;
        if (!buildInteractiveProduct) return false;

        try {
          interactiveProduct = buildInteractiveProduct({
            options: { product },
          });
        } catch (_) {
          interactiveProduct = buildInteractiveProduct({ product });
        }
        if (
          !interactiveProduct ||
          typeof interactiveProduct.select !== "function"
        ) {
          return false;
        }
        renderedProduct.interactiveProduct = interactiveProduct;
      }
      interactiveProduct.select();
      return true;
    } catch (error) {
      renderedProduct.interactiveProduct = null;
      console.warn(
        "[Coveo Recs] interactiveProduct.select failed:",
        error,
      );
      return false;
    }
  }

  function wireRecommendationProductClickAnalytics(instance) {
    const { container, controller } = instance;
    if (!container || typeof container.addEventListener !== "function") return;

    const onProductClick = function (event) {
      const target = event && event.target;
      if (!target || typeof target.closest !== "function") return;
      const anchor = target.closest(RECOMMENDATION_PRODUCT_LINK_SELECTOR);
      if (!anchor || !container.contains(anchor)) return;
      const href = anchor.getAttribute("href");
      if (!href || href === "#") return;

      const productElement = anchor.closest(RECOMMENDATION_PRODUCT_SELECTOR);
      if (!productElement || !container.contains(productElement)) return;
      const trackingId = productElement.getAttribute(
        "data-coveo-recommendation-product",
      );
      const renderedProduct = instance.renderedProducts.get(trackingId);
      if (!renderedProduct) return;

      // Let Headless preserve the slot responseId, result position, and other
      // attribution fields from the original recommendation response. Reusing
      // this sub-controller also lets Coveo deduplicate browser event sequences.
      selectRecommendationProduct(controller, renderedProduct);
    };

    instance.onProductClick = onProductClick;
    RECOMMENDATION_PRODUCT_SELECTION_EVENTS.forEach((eventName) => {
      container.addEventListener(eventName, onProductClick, true);
    });
  }

  window.initCoveoHeadlessRecommendations = function (options) {
    const { containerId, slotId, productId, limit, enableSlider, sectionId } =
      options || {};
    const hideWhenEmpty = !!(options && options.hideWhenEmpty);
    const hideUntilLoaded = !!(options && options.hideUntilLoaded);

    const container = document.getElementById(containerId);
    if (!container || !slotId) return Promise.resolve(false);

    const configKey = getRecommendationConfigKey(options);
    const existingInstance = recommendationInstances.get(containerId);
    if (
      existingInstance &&
      existingInstance.container === container &&
      existingInstance.configKey === configKey &&
      existingInstance.engineInput === options?.engine
    ) {
      return existingInstance.promise;
    }
    if (existingInstance) {
      disposeRecommendationInstance(containerId, existingInstance);
    }

    const instance = {
      active: true,
      configKey,
      container,
      controller: null,
      engine: null,
      engineInput: options?.engine,
      onProductClick: null,
      promise: null,
      renderedError: undefined,
      renderedProductsState: null,
      renderedResponseId: null,
      renderedProducts: new Map(),
      renderVersion: 0,
      unsubscribe: null,
    };

    const initialization = Promise.resolve().then(async function () {
      const section = getRecommendationsSection(sectionId, container);
      if (section) {
        if (options && options.columnsDesktop != null) {
          section.dataset.coveoColumnsDesktop = String(options.columnsDesktop);
        }
        if (options && options.columnsTablet != null) {
          section.dataset.coveoColumnsTablet = String(options.columnsTablet);
        }
        if (options && options.columnsMobile != null) {
          section.dataset.coveoColumnsMobile = String(options.columnsMobile);
        }
      }
      if (hideUntilLoaded) {
        setRecommendationsSectionVisible(sectionId, container, false);
      }

      try {
        let engine = options && options.engine;
        const usesSharedEngine = !!engine;
        if (!engine) {
          const configRes = await fetch(
            options.configUrl ||
              buildCoveoAppProxyUrl(options.marketId || ""),
          );
          if (!configRes.ok) throw new Error("Coveo config fetch failed");
          const config = await configRes.json();

          if (typeof window.configureHeadless !== "function") {
            console.error(
              "[Coveo Recs] configureHeadless not found. Ensure engine.liquid is loaded.",
            );
            return false;
          }
          engine = await window.configureHeadless(config);
        }
        if (!isRecommendationInstanceActive(containerId, instance)) return false;
        if (
          (!usesSharedEngine || options?.syncLocationContext === true) &&
          typeof window.syncCoveoEngineLocationContext === "function"
        ) {
          await window.syncCoveoEngineLocationContext(engine, {
            includeStoredLocationWithoutRadius:
              options?.useStoredLocationWithoutRadius !== false,
            clearWhenMissing: true,
          });
        }
        if (!isRecommendationInstanceActive(containerId, instance)) return false;
        const mod = await import(COMMERCE_ESM);
        if (!isRecommendationInstanceActive(containerId, instance)) return false;
        const buildRecommendations = mod.buildRecommendations;
        if (!buildRecommendations) {
          console.error(
            "[Coveo Recs] buildRecommendations not found in commerce module",
          );
          return false;
        }

        const recOptions = { slotId };
        if (productId) {
          recOptions.productId = String(productId).trim();
        }
        console.log(
          `[Coveo Recs] Request slotId=${slotId} productId=${recOptions.productId || "none"}`,
        );
        const recommendations = buildRecommendations(engine, {
          options: recOptions,
        });
        if (!isRecommendationInstanceActive(containerId, instance)) return false;

        instance.controller = recommendations;
        instance.engine = engine;
        wireRecommendationProductClickAnalytics(instance);

        if (!window.__coveoRecommendationsControllers) {
          window.__coveoRecommendationsControllers = {};
        }
        if (!window.__coveoRecommendationsEngines) {
          window.__coveoRecommendationsEngines = {};
        }
        window.__coveoRecommendationsControllers[containerId] = recommendations;
        window.__coveoRecommendationsEngines[containerId] = engine;

        const render = () => {
          if (!isRecommendationInstanceActive(containerId, instance)) return;
          const state = recommendations.state || {};
          const productsState = Array.isArray(state.products)
            ? state.products
            : [];
          if (
            productsState === instance.renderedProductsState &&
            state.error === instance.renderedError &&
            state.responseId === instance.renderedResponseId
          ) {
            return;
          }
          instance.renderedProductsState = productsState;
          instance.renderedError = state.error;
          instance.renderedResponseId = state.responseId;

          const renderVersion = ++instance.renderVersion;
          const products = productsState.filter(
            (p) => !isCoveoPlaceholderSoldGhostProduct(p),
          );
          const error = state.error;

          if (error) {
            instance.renderedProducts.clear();
            container.innerHTML = "";
            if (hideWhenEmpty) {
              setRecommendationsSectionVisible(sectionId, container, false);
            }
            return;
          }

          if (products.length === 0) {
            instance.renderedProducts.clear();
            container.innerHTML = "";
            if (hideWhenEmpty) {
              setRecommendationsSectionVisible(sectionId, container, false);
            }
            return;
          }

          const sliceProducts = limit ? products.slice(0, limit) : products;
          instance.renderedProducts.clear();
          container.innerHTML = sliceProducts
            .map(
              () =>
                '<div class="f-column card coveo-search-card-wrapper coveo-rec-skeleton" role="presentation" aria-hidden="true"><div class="coveo-search-card__placeholder" style="min-height:200px"></div></div>',
            )
            .join("");

          (async () => {
            const list = sliceProducts;
            const n = list.length;
            const workers = Math.min(
              LIQUID_PRODUCT_SECTION_FETCH_CONCURRENCY,
              Math.max(1, n),
            );
            const cards = new Array(n);
            let nextIndex = 0;

            async function hydrateOne(i) {
              const p = list[i];
              let html = await fetchLiquidProductCard(p.clickUri, () =>
                renderFallbackCard(p),
              );
              if (html && String(html).trim()) {
                const probe = document.createElement("div");
                probe.innerHTML = String(html).trim();
                const root = probe.firstElementChild;
                const ghostEl = root?.matches?.(
                  "[data-mm-coveo-ghost-placeholder='1']",
                )
                  ? root
                  : root?.querySelector?.(
                      "[data-mm-coveo-ghost-placeholder='1']",
                );
                if (ghostEl) {
                  html = "";
                }
              }
              cards[i] = html;
            }

            async function worker() {
              while (true) {
                const i = nextIndex++;
                if (i >= n) break;
                await hydrateOne(i);
              }
            }

            await Promise.all(Array.from({ length: workers }, () => worker()));
            if (
              !isRecommendationInstanceActive(containerId, instance) ||
              renderVersion !== instance.renderVersion
            ) {
              return;
            }
            const keptEntries = cards
              .map((card, index) => ({ card, product: list[index] }))
              .filter((entry) => Boolean(entry.card));
            const renderedProducts = new Map();
            const renderedCards = keptEntries
              .map(({ card, product }) => {
                const wrap = document.createElement("div");
                wrap.innerHTML = String(card).trim();
                let el = wrap.firstElementChild;
                if (!el) {
                  wrap.innerHTML = renderFallbackCard(product).trim();
                  el = wrap.firstElementChild;
                }
                if (!el) return "";
                if (el && enableSlider) el.classList.add("swiper-slide");
                const trackingId = `${renderVersion}:${renderedProducts.size}`;
                el.setAttribute(
                  "data-coveo-recommendation-product",
                  trackingId,
                );
                renderedProducts.set(trackingId, {
                  interactiveProduct: null,
                  product,
                });
                return el.outerHTML;
              })
              .filter(Boolean);
            const html = renderedCards
              .join("");
            if (renderedCards.length) {
              container.innerHTML = html;
              instance.renderedProducts = renderedProducts;
              setRecommendationsSectionVisible(sectionId, container, true);
            } else {
              instance.renderedProducts.clear();
              container.innerHTML = "";
              if (hideWhenEmpty) {
                setRecommendationsSectionVisible(sectionId, container, false);
              }
            }
            if (
              enableSlider &&
              sectionId &&
              !container.dataset.coveoRecScrollWired &&
              setupCarouselScroll(sectionId)
            ) {
              container.dataset.coveoRecScrollWired = "1";
            }
            requestAnimationFrame(() => {
              syncRecommendationsControls(sectionId, container, renderedCards.length);
            });
            setTimeout(() => {
              syncRecommendationsControls(sectionId, container, renderedCards.length);
            }, 180);
          })();
        };

        function setupCarouselScroll(sid) {
          const section = document.querySelector(".section-" + sid);
          if (!section) return false;
          const scrollContainer = section.querySelector(
            "#coveo-recommendations-grid-" + sid,
          );
          const prevBtn = section.querySelector(".swiper-button-prev");
          const nextBtn = section.querySelector(".swiper-button-next");
          if (!scrollContainer) return false;
          const scrollBy = (dir) => {
            const step = scrollContainer.clientWidth * 0.8;
            scrollContainer.scrollBy({ left: dir * step, behavior: "smooth" });
          };
          if (prevBtn) prevBtn.addEventListener("click", () => scrollBy(-1));
          if (nextBtn) nextBtn.addEventListener("click", () => scrollBy(1));

          const interactiveSelector =
            "a[href], button, [role='button'], input, label, select, textarea";

          // Touch/mouse drag-to-scroll fallback for custom carousel tracks.
          let isPointerDown = false;
          let pointerId = null;
          let startX = 0;
          let startY = 0;
          let startScrollLeft = 0;
          let hasMoved = false;
          let blockClickUntil = 0;

          const onPointerDown = (e) => {
            if (e.pointerType === "mouse" && e.button !== 0) return;
            /* Never capture the pointer when the gesture starts on a product link or
               other control — setPointerCapture would retarget pointerup away from
               the <a> and the browser may not emit a real click (desktop carousel). */
            if (e.target && e.target.closest(interactiveSelector)) return;
            isPointerDown = true;
            pointerId = e.pointerId;
            startX = e.clientX;
            startY = e.clientY;
            startScrollLeft = scrollContainer.scrollLeft;
            hasMoved = false;
            scrollContainer.classList.add("is-dragging");
            try {
              scrollContainer.setPointerCapture(pointerId);
            } catch (_) {}
          };

          const onPointerMove = (e) => {
            if (!isPointerDown || e.pointerId !== pointerId) return;
            const dx = e.clientX - startX;
            const dy = e.clientY - startY;
            if (!hasMoved && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) {
              hasMoved = true;
            }
            if (!hasMoved) return;
            e.preventDefault();
            scrollContainer.scrollLeft = startScrollLeft - dx;
          };

          const onPointerEnd = (e) => {
            if (pointerId != null && e.pointerId !== pointerId) return;
            if (hasMoved) {
              blockClickUntil = Date.now() + 250;
            }
            isPointerDown = false;
            pointerId = null;
            hasMoved = false;
            scrollContainer.classList.remove("is-dragging");
          };

          scrollContainer.addEventListener("pointerdown", onPointerDown, {
            passive: true,
          });
          scrollContainer.addEventListener("pointermove", onPointerMove, {
            passive: false,
          });
          scrollContainer.addEventListener("pointerup", onPointerEnd, {
            passive: true,
          });
          scrollContainer.addEventListener("pointercancel", onPointerEnd, {
            passive: true,
          });
          scrollContainer.addEventListener(
            "click",
            (e) => {
              if (Date.now() >= blockClickUntil) return;
              /* Do not block taps on product links / buttons after a horizontal drag. */
              if (e.target && e.target.closest(interactiveSelector)) {
                return;
              }
              e.preventDefault();
              e.stopPropagation();
            },
            true,
          );
          return true;
        }

        const unsubscribe = recommendations.subscribe(render);
        if (typeof unsubscribe === "function") {
          instance.unsubscribe = unsubscribe;
        }
        recommendations.refresh();
        return true;
      } catch (err) {
        console.error("[Coveo Recs] Init error:", err);
        if (isRecommendationInstanceActive(containerId, instance)) {
          container.innerHTML = "";
        }
        return false;
      }
    });

    instance.promise = initialization.then(
      function (initialized) {
        if (!initialized) {
          disposeRecommendationInstance(containerId, instance);
        }
        return initialized;
      },
      function (error) {
        console.error("[Coveo Recs] Init error:", error);
        if (isRecommendationInstanceActive(containerId, instance)) {
          container.innerHTML = "";
        }
        disposeRecommendationInstance(containerId, instance);
        return false;
      },
    );
    recommendationInstances.set(containerId, instance);
    return instance.promise;
  };

  window.refreshCoveoHeadlessRecommendationsLocation = async function (
    containerId,
    options,
  ) {
    const engine = window.__coveoRecommendationsEngines?.[containerId];
    const recommendations =
      window.__coveoRecommendationsControllers?.[containerId];
    if (!engine || !recommendations) return false;
    if (typeof window.syncCoveoEngineLocationContext === "function") {
      await window.syncCoveoEngineLocationContext(engine, {
        includeStoredLocationWithoutRadius:
          options?.useStoredLocationWithoutRadius !== false,
        clearWhenMissing: true,
      });
    }
    await recommendations.refresh();
    return true;
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      function () {
        initializeRecommendationConfigs(document);
      },
      { once: true },
    );
  } else {
    initializeRecommendationConfigs(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initializeRecommendationConfigs(event.target || document);
  });

  document.addEventListener("turbo:load", function () {
    initializeRecommendationConfigs(document);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    const section = event.target;
    recommendationBootstraps.forEach(function (bootstrap, containerId) {
      const belongsToSection =
        section === bootstrap.configElement ||
        section === bootstrap.container ||
        (section &&
          typeof section.contains === "function" &&
          (section.contains(bootstrap.configElement) ||
            section.contains(bootstrap.container)));
      if (belongsToSection) {
        disposeRecommendationBootstrap(containerId, bootstrap);
        disposeRecommendationInstance(containerId);
      }
    });
    recommendationInstances.forEach(function (instance, containerId) {
      const belongsToSection =
        section === instance.container ||
        (section &&
          typeof section.contains === "function" &&
          section.contains(instance.container));
      if (belongsToSection) {
        disposeRecommendationInstance(containerId, instance);
      }
    });
  });

  window.addEventListener("pageshow", function () {
    recommendationBootstraps.forEach(function (bootstrap, containerId) {
      if (!bootstrap.config.refreshOnPageShow || !bootstrap.started) return;
      const controller =
        window.__coveoRecommendationsControllers?.[containerId];
      if (controller && typeof controller.refresh === "function") {
        controller.refresh();
        return;
      }
      bootstrap.promise = window.initCoveoHeadlessRecommendations(
        bootstrap.options,
      );
    });
  });

  window.MarineMaxHeadlessRecommendationsRuntime = Object.freeze({
    destroy: function (containerId) {
      return disposeRecommendationInstance(containerId);
    },
    has: function (containerId) {
      return recommendationInstances.has(containerId);
    },
    initialize: initializeRecommendationConfigs,
  });
})();
